import { IntentSelect } from './IntentSelect'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  intents: state.intents,
  activeBot: state.activeBot,
})

export default connect(mapStateToProps)(IntentSelect)
